module.exports = __webpack_public_path__ + "f0f6f8872825b1c0bf8f442011270db6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-white.png
// module id = 1787
// module chunks = 0